import { render, staticRenderFns } from "./staffCustomer.vue?vue&type=template&id=3ca37b1e"
import script from "./staffCustomer.vue?vue&type=script&lang=js"
export * from "./staffCustomer.vue?vue&type=script&lang=js"
import style0 from "./staffCustomer.vue?vue&type=style&index=0&id=3ca37b1e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports